import * as React from "react";
import { useCallback, useEffect, useState } from "react";
import styled, { css } from "styled-components";
import { IconButton } from "components/common";
import MDBaseEditor from "./BaseEditor";
import Preview from "./Preview";
import EditorModal from "./EditorModal";
const TabsRow = styled.div`
  position: relative;
  bottom: -1px;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: 5px;
  padding: 0 8px;
  z-index: 1;
`;
const Tab = styled.div`
  padding: 4px 8px;
  border: none;
  border-bottom: 1px solid ${({ theme }) => theme.colors.input.border};
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  background-color: ${({ theme }) => theme.colors.global.contentBackground};
  color: ${({ theme, $active }) => $active ? theme.colors.text.primary : theme.colors.input.placeholder};
  cursor: pointer;

  ${({ $active }) => $active && css`
      border: 1px solid ${({ theme }) => theme.colors.input.border};
      border-bottom-color: ${({ theme }) => theme.colors.global.contentBackground};
    `}
`;
const ExpandIconButton = styled(IconButton)`
  position: absolute;
  bottom: 0;
  right: 0;
  padding: 8px;
  cursor: pointer;
  z-index: 10;
`;
function Editor({ id = void 0, value, height, readOnly = false, onChange, onFullMode = () => {
} }) {
  const [localValue, setLocalValue] = useState(value);
  const [showPreview, setShowPreview] = useState(false);
  const [fullView, setFullView] = useState(false);
  useEffect(() => setLocalValue(value), [value]);
  const handleOnFullMode = (fullMode) => {
    setFullView(fullMode);
    if (onFullMode) onFullMode(fullMode);
  };
  const handleOnChange = useCallback(
    (newValue) => {
      setLocalValue(newValue);
      onChange(newValue);
    },
    [onChange]
  );
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { style: { position: "relative" } }, /* @__PURE__ */ React.createElement(TabsRow, null, /* @__PURE__ */ React.createElement(Tab, { $active: !showPreview, onClick: () => setShowPreview(false) }, "Edit"), /* @__PURE__ */ React.createElement(Tab, { $active: showPreview, onClick: () => setShowPreview(true) }, "Preview")), !showPreview && /* @__PURE__ */ React.createElement(
    MDBaseEditor,
    {
      id,
      onChange: handleOnChange,
      value: localValue,
      readOnly,
      height,
      onBlur: handleOnChange
    }
  ), /* @__PURE__ */ React.createElement(Preview, { value: localValue, height, show: showPreview }), /* @__PURE__ */ React.createElement(
    ExpandIconButton,
    {
      "data-testid": "expand-icon",
      name: "expand_content",
      title: "Expand Preview",
      onClick: () => handleOnFullMode(true),
      size: "sm",
      "aria-label": "Expand preview"
    }
  )), fullView && /* @__PURE__ */ React.createElement(
    EditorModal,
    {
      show: true,
      value: localValue,
      readOnly,
      onChange: handleOnChange,
      onClose: () => handleOnFullMode(false)
    }
  ));
}
export default Editor;
